import { BoldOutlined } from '@ant-design/icons'
import { Flex } from 'antd'

import { BasicProps } from '@eastcoal/common/types/component'

import { useSelectionTextFormat } from '../../hooks/useSelectionTextFormat'
import { SHORTCUTS } from '../../plugins/ShortcutsPlugin/shortcuts'
import { MenuButton } from '../../ui/MenuButton'

export const BoldButton = (props: BasicProps) => {
  const [bold, toggleBold] = useSelectionTextFormat('bold')

  return (
    <MenuButton
      {...props}
      actived={bold}
      tooltip={
        <Flex vertical align='center'>
          <span>加粗</span>
          <span>{SHORTCUTS.BOLD}</span>
        </Flex>
      }
      onClick={toggleBold}
    >
      <BoldOutlined />
    </MenuButton>
  )
}
